var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCreateCard(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.8842 13.291H18.7288C18.1607 13.291 17.6331 13.3113 17.1461 13.3316C12.337 13.6157 11.0586 15.3811 11.0586 20.8598V22.0367C11.0586 23.1528 11.9717 24.0659 13.0878 24.0659H43.5253C44.6413 24.0659 45.5544 23.1528 45.5544 22.0367V20.8598C45.5544 14.8129 44.0123 13.291 37.8842 13.291Z",
    fill: "#2566AF",
    fillOpacity: 0.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0878 27.1099C11.9717 27.1099 11.0586 28.023 11.0586 29.139V35.0439C11.0586 41.0908 12.6008 42.6127 18.7288 42.6127H37.8842C43.9108 42.6127 45.4936 41.1517 45.5544 35.3686V29.139C45.5544 28.023 44.6413 27.1099 43.5253 27.1099H13.0878ZM21.1233 37.6615H17.6534C16.8214 37.6615 16.1315 36.9716 16.1315 36.1397C16.1315 35.3077 16.8214 34.6178 17.6534 34.6178H21.1436C21.9755 34.6178 22.6654 35.3077 22.6654 36.1397C22.6654 36.9716 21.9755 37.6615 21.1233 37.6615ZM32.4663 37.6615H25.486C24.654 37.6615 23.9641 36.9716 23.9641 36.1397C23.9641 35.3077 24.654 34.6178 25.486 34.6178H32.4663C33.2983 34.6178 33.9882 35.3077 33.9882 36.1397C33.9882 36.9716 33.3186 37.6615 32.4663 37.6615Z",
    fill: "#2566AF",
    fillOpacity: 0.1
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M51.6407 27.049V16.4161C51.6407 10.0648 48.0085 7.30518 42.5298 7.30518H24.4093C22.8672 7.30518 21.4873 7.52838 20.2698 7.99509C19.3161 8.34005 18.4639 8.84734 17.7739 9.51697C17.4087 9.86193 17.6928 10.4301 18.2204 10.4301H40.2774C44.843 10.4301 48.5361 14.1232 48.5361 18.6888V33.2379C48.5361 33.7452 49.084 34.0293 49.4492 33.6641C50.8494 32.1828 51.6407 30.0116 51.6407 27.049Z",
    fill: "#2566AF",
    fillOpacity: 0.1
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.05859 32.5879H38.5544",
    stroke: "#2566AF",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7935 49.6125H11.7289C5.60082 49.6125 4.05859 48.0906 4.05859 42.0437V27.8598C4.05859 22.3811 5.33697 20.6157 10.1461 20.3316C10.6331 20.3113 11.1607 20.291 11.7289 20.291H30.8841C37.0122 20.291 38.5544 21.8129 38.5544 27.8598V42.3684C38.4936 48.1515 36.9107 49.6125 30.8841 49.6125",
    stroke: "#2566AF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M44.6423 20.6562V34.8401C44.6423 40.3188 43.3639 42.0842 38.5548 42.3683V27.8597C38.5548 21.8128 37.0126 20.2909 30.8845 20.2909H11.7293C11.1611 20.2909 10.6335 20.3112 10.1465 20.3315C10.2074 14.5484 11.7902 13.0874 17.8168 13.0874H36.972C43.1001 13.0874 44.6423 14.6093 44.6423 20.6562Z",
    stroke: "#2566AF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6523 43.1396H14.1425",
    stroke: "#2566AF",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4863 43.1396H25.4667",
    stroke: "#2566AF",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreateCard);
export default __webpack_public_path__ + "static/media/create-card.67fbc30cc30ae31da2cc2ef57d54b8f3.svg";
export { ForwardRef as ReactComponent };